export const googleIcon = (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.5322 20.7329C30.5322 20.0061 30.4669 19.3073 30.3458 18.6364H20.6921V22.6012H26.2085C25.9709 23.8825 25.2487 24.9681 24.1632 25.6949V28.2667H27.4758C29.414 26.4823 30.5322 23.8545 30.5322 20.7329Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6918 30.7499C23.4593 30.7499 25.7795 29.8321 27.4754 28.2666L24.1628 25.6948C23.245 26.3098 22.0709 26.6732 20.6918 26.6732C18.0221 26.6732 15.7624 24.8701 14.9564 22.4474H11.532V25.1031C13.2186 28.453 16.6849 30.7499 20.6918 30.7499Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9568 22.4474C14.7518 21.8324 14.6353 21.1755 14.6353 20.4999C14.6353 19.8244 14.7518 19.1674 14.9568 18.5524V15.8967H11.5324C10.8382 17.2805 10.4421 18.8459 10.4421 20.4999C10.4421 22.1539 10.8382 23.7194 11.5324 25.1031L14.9568 22.4474Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6918 14.3267C22.1967 14.3267 23.5478 14.8439 24.6101 15.8596L27.55 12.9197C25.7749 11.2657 23.4546 10.25 20.6918 10.25C16.6849 10.25 13.2186 12.5469 11.532 15.8968L14.9564 18.5525C15.7624 16.1298 18.0221 14.3267 20.6918 14.3267Z"
      fill="#EA4335"
    />
  </svg>
);

export const facebookIcon = (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 20.5C0 31.8218 9.17816 41 20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5Z"
      fill="#1877F2"
    />
    <path
      d="M30.75 20.5C30.75 14.8625 26.1375 10.25 20.5 10.25C14.8625 10.25 10.25 14.8625 10.25 20.5C10.25 25.625 13.9656 29.8531 18.8344 30.6219V23.4469H16.2719V20.5H18.8344V18.1937C18.8344 15.6312 20.3719 14.2219 22.6781 14.2219C23.8313 14.2219 24.9844 14.4781 24.9844 14.4781V17.0406H23.7031C22.4219 17.0406 22.0375 17.8094 22.0375 18.5781V20.5H24.8562L24.3438 23.4469H21.9094V30.75C27.0344 29.9813 30.75 25.625 30.75 20.5Z"
      fill="white"
    />
  </svg>
);
export const RightBtn = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="23" height="23" rx="8" fill="#F8F8F8" />
    <path
      d="M10 16L14 11.5L10 7"
      stroke="#8F8F8F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LeftBtn = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="23"
      height="23"
      rx="8"
      transform="matrix(-1 0 0 1 23 0)"
      fill="#F8F8F8"
    />
    <path
      d="M13 16L9 11.5L13 7"
      stroke="#8F8F8F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const More_horiz = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14ZM6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14ZM12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14Z"
      fill="#C4C4C4"
    />
  </svg>
);
export const SearchIcon = ({ color = "#FF6B38" }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1189_19083)">
      <path
        d="M7.16296 14.2951C5.33212 14.2951 3.50129 13.5899 2.08801 12.2117C-0.706421 9.42328 -0.706421 4.872 2.08801 2.08353C4.88244 -0.704928 9.44347 -0.704928 12.2379 2.08353C15.0323 4.872 15.0323 9.42328 12.2379 12.2117C10.8246 13.5899 8.99379 14.2951 7.16296 14.2951ZM7.16296 1.08994C5.6212 1.08994 4.04733 1.66687 2.85889 2.85276C0.514136 5.22456 0.514136 9.07071 2.89101 11.4425C5.26788 13.7823 9.09015 13.8143 11.467 11.4425C13.8439 9.07071 13.8439 5.25661 11.467 2.88482C10.2786 1.69892 8.73683 1.122 7.16296 1.122V1.08994Z"
        fill="#706F6F"
      />
      <path
        d="M14.6247 14.59C14.4088 14.8143 14.0506 14.8169 13.8315 14.5958L11.8517 12.5972C11.64 12.3835 11.641 12.0388 11.8539 11.8263C12.0671 11.6136 12.4122 11.6136 12.6254 11.8263L14.6167 13.8134C14.8306 14.0268 14.8341 14.3722 14.6247 14.59Z"
        fill="#706F6F"
      />
    </g>
    <defs>
      <clipPath id="clip0_1189_19083">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const threeHorizontalLineIcon = (
  <svg
    fill="#fff"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 124 124"
  >
    <g>
      <path d="M112,6H12C5.4,6,0,11.4,0,18s5.4,12,12,12h100c6.6,0,12-5.4,12-12S118.6,6,112,6z" />
      <path d="M112,50H12C5.4,50,0,55.4,0,62c0,6.6,5.4,12,12,12h100c6.6,0,12-5.4,12-12C124,55.4,118.6,50,112,50z" />
      <path d="M112,94H12c-6.6,0-12,5.4-12,12s5.4,12,12,12h100c6.6,0,12-5.4,12-12S118.6,94,112,94z" />
    </g>
  </svg>
);
export const QuestionMark = ({ color = "#FF6B38" }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0.5C5.20312 0.5 0.5 5.20312 0.5 11C0.5 16.7969 5.20312 21.5 11 21.5C16.7969 21.5 21.5 16.7969 21.5 11C21.5 5.20312 16.7969 0.5 11 0.5ZM10.6719 17.125C10.4555 17.125 10.2441 17.0609 10.0642 16.9407C9.88435 16.8205 9.74416 16.6497 9.66138 16.4498C9.5786 16.2499 9.55694 16.03 9.59914 15.8179C9.64134 15.6057 9.74551 15.4108 9.89847 15.2578C10.0514 15.1049 10.2463 15.0007 10.4585 14.9585C10.6707 14.9163 10.8906 14.938 11.0904 15.0208C11.2903 15.1035 11.4611 15.2437 11.5813 15.4236C11.7015 15.6035 11.7656 15.8149 11.7656 16.0312C11.7656 16.3213 11.6504 16.5995 11.4453 16.8046C11.2402 17.0098 10.962 17.125 10.6719 17.125ZM12.5006 11.5469C11.6141 12.1419 11.4922 12.6871 11.4922 13.1875C11.4922 13.3906 11.4115 13.5853 11.2679 13.7289C11.1244 13.8725 10.9296 13.9531 10.7266 13.9531C10.5235 13.9531 10.3288 13.8725 10.1852 13.7289C10.0416 13.5853 9.96094 13.3906 9.96094 13.1875C9.96094 11.9893 10.5122 11.0366 11.6464 10.2748C12.7008 9.56719 13.2969 9.11875 13.2969 8.13273C13.2969 7.46226 12.9141 6.95312 12.1216 6.57633C11.9352 6.48773 11.5201 6.40133 11.0093 6.40734C10.3684 6.41555 9.8707 6.56867 9.48734 6.87711C8.76437 7.45898 8.70312 8.09226 8.70312 8.10156C8.69828 8.2021 8.67367 8.30071 8.63072 8.39174C8.58776 8.48278 8.5273 8.56446 8.45277 8.63213C8.37825 8.69979 8.29113 8.75212 8.19639 8.78612C8.10164 8.82012 8.00113 8.83512 7.90058 8.83027C7.80004 8.82542 7.70144 8.80082 7.6104 8.75787C7.51937 8.71491 7.43769 8.65445 7.37002 8.57992C7.30235 8.5054 7.25002 8.41828 7.21603 8.32353C7.18203 8.22879 7.16703 8.12828 7.17187 8.02773C7.17789 7.89484 7.27031 6.69773 8.52648 5.68711C9.17781 5.1632 10.0063 4.89086 10.9874 4.87883C11.682 4.87062 12.3344 4.9882 12.7768 5.19711C14.1008 5.82328 14.8281 6.86726 14.8281 8.13273C14.8281 9.98281 13.5916 10.8135 12.5006 11.5469Z"
      fill="#FF6B38"
    />
  </svg>
);
export const BgQuestionMark = ({ color = "#FF6B38" }) => (
  <svg
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.875"
      y="0.374969"
      width="26.25"
      height="26.25"
      rx="9"
      fill="url(#paint0_linear_94_7862)"
    />
    <path
      d="M14 6.75C10.2734 6.75 7.25 9.77344 7.25 13.5C7.25 17.2266 10.2734 20.25 14 20.25C17.7266 20.25 20.75 17.2266 20.75 13.5C20.75 9.77344 17.7266 6.75 14 6.75ZM13.7891 17.4375C13.65 17.4375 13.5141 17.3963 13.3984 17.319C13.2828 17.2417 13.1927 17.1319 13.1395 17.0034C13.0862 16.875 13.0723 16.7336 13.0994 16.5972C13.1266 16.4608 13.1935 16.3355 13.2919 16.2372C13.3902 16.1389 13.5155 16.0719 13.6519 16.0448C13.7883 16.0176 13.9297 16.0316 14.0581 16.0848C14.1866 16.138 14.2964 16.2281 14.3737 16.3437C14.4509 16.4594 14.4922 16.5953 14.4922 16.7344C14.4922 16.9209 14.4181 17.0997 14.2862 17.2316C14.1544 17.3634 13.9755 17.4375 13.7891 17.4375ZM14.9647 13.8516C14.3948 14.2341 14.3164 14.5846 14.3164 14.9062C14.3164 15.0368 14.2645 15.162 14.1722 15.2543C14.0799 15.3466 13.9548 15.3984 13.8242 15.3984C13.6937 15.3984 13.5685 15.3466 13.4762 15.2543C13.3839 15.162 13.332 15.0368 13.332 14.9062C13.332 14.136 13.6864 13.5236 14.4155 13.0338C15.0934 12.5789 15.4766 12.2906 15.4766 11.6568C15.4766 11.2257 15.2305 10.8984 14.7211 10.6562C14.6012 10.5993 14.3343 10.5437 14.006 10.5476C13.5939 10.5529 13.274 10.6513 13.0276 10.8496C12.5628 11.2236 12.5234 11.6307 12.5234 11.6367C12.5203 11.7014 12.5045 11.7647 12.4769 11.8233C12.4493 11.8818 12.4104 11.9343 12.3625 11.9778C12.3146 12.0213 12.2586 12.0549 12.1977 12.0768C12.1368 12.0986 12.0722 12.1083 12.0075 12.1052C11.9429 12.1021 11.8795 12.0862 11.821 12.0586C11.7625 12.031 11.7099 11.9921 11.6664 11.9442C11.6229 11.8963 11.5893 11.8403 11.5674 11.7794C11.5456 11.7185 11.5359 11.6539 11.5391 11.5893C11.5429 11.5038 11.6023 10.7343 12.4099 10.0846C12.8286 9.74777 13.3612 9.5727 13.9919 9.56496C14.4384 9.55969 14.8578 9.63527 15.1422 9.76957C15.9934 10.1721 16.4609 10.8432 16.4609 11.6568C16.4609 12.8461 15.6661 13.3801 14.9647 13.8516Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_94_7862"
        x1="27.125"
        y1="13.3796"
        x2="0.875"
        y2="13.3796"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6B38" />
        <stop offset="1" stopColor="#FFE39C" />
      </linearGradient>
    </defs>
  </svg>
);
export const NotificationIcon = ({ color = "#FF6B38" }) => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 82 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1189_19109)">
      <rect x="18" y="10" width="46" height="50" rx="16" fill="#F8F8F8" />
      <path
        d="M49.2751 39.9699L49.2757 39.9707L50.1062 39.805L49.5237 40.2776C49.5239 40.2778 49.5241 40.2781 49.5243 40.2783C49.6519 40.4358 49.7338 40.6289 49.7585 40.8351C49.7833 41.0417 49.7494 41.2507 49.6617 41.437L49.6612 41.4381C49.4732 41.8391 49.0787 42.0947 48.604 42.0947H32.9182C32.4379 42.0947 32.0412 41.8369 31.855 41.4366L31.8539 41.4344C31.7666 41.2482 31.7331 41.0394 31.758 40.8331C31.783 40.6268 31.8653 40.4338 31.9931 40.2765L31.9931 40.2765L31.9974 40.2711C32.069 40.1813 32.1394 40.0947 32.2111 40.0064C32.2212 39.994 32.2313 39.9816 32.2415 39.9691L32.2416 39.9689L32.2639 39.9415C32.8115 39.2672 33.33 38.6285 33.682 37.6379C34.0328 36.6503 34.2025 35.3658 34.2025 33.3817C34.2025 31.7052 34.5315 30.3864 35.1483 29.3637C35.7604 28.3487 36.6904 27.5678 37.9974 27.0188L38.0391 27.0012L38.0784 26.9788C38.1672 26.9282 38.2464 26.8632 38.313 26.7869L38.4214 26.6627L38.4678 26.5045C38.8349 25.2513 39.7938 24.5273 40.7583 24.5273C41.7229 24.5273 42.6822 25.2513 43.0494 26.5058L43.0936 26.6568L43.1947 26.7774C43.2635 26.8592 43.3466 26.9288 43.4406 26.9821L43.4794 27.0041L43.5205 27.0214C44.6442 27.4932 45.4602 28.1143 46.057 28.9104L46.0574 28.911C46.8679 29.9904 47.3148 31.4759 47.3148 33.3833C47.3148 35.3667 47.4846 36.6508 47.8357 37.6384C48.1872 38.6274 48.7046 39.2659 49.2506 39.9397L49.2751 39.9699Z"
        stroke="#8F8F8F"
        strokeWidth="1.5"
      />
      <path
        d="M40.7563 46.9912C41.4901 46.9905 42.2101 46.7873 42.8399 46.4029C43.4696 46.0186 43.9857 45.4675 44.3334 44.8081C44.3497 44.7765 44.3578 44.7411 44.3568 44.7054C44.3559 44.6696 44.3458 44.6348 44.3277 44.6041C44.3097 44.5735 44.2841 44.5482 44.2536 44.5306C44.2231 44.5131 44.1886 44.5039 44.1536 44.5039H37.3601C37.325 44.5038 37.2905 44.5129 37.2599 44.5305C37.2293 44.548 37.2037 44.5733 37.1856 44.6039C37.1674 44.6345 37.1573 44.6694 37.1563 44.7052C37.1553 44.741 37.1634 44.7764 37.1798 44.8081C37.5274 45.4674 38.0434 46.0185 38.6731 46.4028C39.3028 46.7872 40.0226 46.9905 40.7563 46.9912Z"
        fill="#8F8F8F"
      />
      <circle
        cx="35"
        cy="28.5"
        r="3"
        fill="#FF3D4A"
        stroke="white"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1189_19109"
        x="0"
        y="-4"
        width="82"
        height="86"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="9" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.294118 0 0 0 0 0.27451 0 0 0 0 0.360784 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1189_19109"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1189_19109"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const MessageIcon = ({ color = "#FF6B38" }) => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 82 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_619_86142)">
      <rect x="18" y="10" width="46" height="50" rx="16" fill="#F8F8F8" />
      <rect
        x="31.5"
        y="27.3438"
        width="18"
        height="14.2857"
        rx="2"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 29.3867L40.5 35.5092L49.5 29.3867"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="31"
        cy="27"
        r="3"
        fill="#FF3D4A"
        stroke="white"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_619_86142"
        x="0"
        y="-4"
        width="82"
        height="86"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="9" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.294118 0 0 0 0 0.27451 0 0 0 0 0.360784 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_619_86142"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_619_86142"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const MenuIcon = ({ color }) => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 82 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_619_86145)">
      <rect x="18" y="10" width="46" height="50" rx="16" fill="#F8F8F8" />
      <rect x="46" y="24" width="5" height="5" rx="2" fill={color} />
      <rect x="46" y="32" width="5" height="5" rx="2" fill={color} />
      <rect x="46" y="40" width="5" height="5" rx="2" fill={color} />
      <rect x="38" y="24" width="5" height="5" rx="2" fill={color} />
      <rect x="38" y="32" width="5" height="5" rx="2" fill={color} />
      <rect x="38" y="40" width="5" height="5" rx="2" fill={color} />
      <rect x="30" y="24" width="5" height="5" rx="2" fill={color} />
      <rect x="30" y="32" width="5" height="5" rx="2" fill={color} />
      <rect x="30" y="40" width="5" height="5" rx="2" fill={color} />
    </g>
    <defs>
      <filter
        id="filter0_d_619_86145"
        x="0"
        y="-4"
        width="82"
        height="86"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="9" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.294118 0 0 0 0 0.27451 0 0 0 0 0.360784 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_619_86145"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_619_86145"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const DarkMode = ({ color = "#FF6B38" }) => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 82 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1189_19106)">
      <rect x="18" y="10" width="46" height="50" rx="16" fill="#F8F8F8" />
      <path
        d="M39.7466 35.3386C38.7368 30.8046 40.8517 26.3084 44.6665 24.055C43.5699 23.9437 42.4373 23.9983 41.3026 24.2461C35.5952 25.4978 31.99 31.1007 33.2517 36.7624C34.5113 42.4242 40.1616 46.0006 45.869 44.7511C47.0037 44.5032 48.0537 44.079 49 43.5204C44.5818 43.071 40.7564 39.8747 39.7466 35.3386Z"
        fill="#8F8F8F"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1189_19106"
        x="0"
        y="-4"
        width="82"
        height="86"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="9" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.294118 0 0 0 0 0.27451 0 0 0 0 0.360784 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1189_19106"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1189_19106"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const HomeIcon = ({ color = "#FF6B38" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1396_16657)">
      <g filter="url(#filter0_i_1396_16657)">
        <path
          d="M7.58193 17.9996C7.58193 17.868 7.58193 17.7735 7.58193 17.6795C7.58193 16.1649 7.58139 14.6504 7.58193 13.1364C7.58193 12.5483 7.89028 12.2538 8.50422 12.2507C8.85091 12.2491 9.19813 12.2475 9.54481 12.2507C10.1034 12.2559 10.4222 12.5619 10.4227 13.0993C10.4249 14.6222 10.4233 16.1456 10.4233 17.6685C10.4233 17.7636 10.4233 17.8586 10.4233 17.9866C10.5224 17.9913 10.609 17.9986 10.6955 17.9986C11.9004 17.9991 13.1053 18.0001 14.3096 17.9986C15.2067 17.997 15.7582 17.4695 15.7588 16.6125C15.7599 14.3757 15.7588 12.1389 15.7588 9.90207V9.57358C16.1416 9.57358 16.5124 9.57514 16.8826 9.57358C17.2468 9.57201 17.6296 9.654 17.8378 9.21844C18.0563 8.76095 18.0672 8.32905 17.7896 7.90184C17.714 7.78538 17.6088 7.68354 17.5064 7.58536C15.0243 5.21537 12.539 2.8459 10.0542 0.47696C9.39092 -0.155489 8.62088 -0.159667 7.96148 0.468604C5.46297 2.84956 2.965 5.23104 0.468138 7.61304C-0.0932331 8.14835 -0.156761 8.90353 0.327387 9.41638C0.406252 9.49994 0.554672 9.56261 0.673517 9.56679C1.14726 9.58402 1.62265 9.57358 2.09694 9.57514C2.1402 9.57514 2.18347 9.58977 2.24755 9.60126C2.24755 9.70414 2.24755 9.79762 2.24755 9.89163C2.24755 12.1112 2.24755 14.3303 2.24755 16.5498C2.24755 17.4977 2.77332 17.9991 3.76681 17.9996C4.935 18.0001 6.1032 17.9996 7.2714 17.9996C7.36122 17.9996 7.45104 17.9996 7.58193 17.9996Z"
          fill={color}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_1396_16657"
        x="0.00390625"
        y="0"
        width="17.9961"
        height="18"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1396_16657"
        />
      </filter>
      <clipPath id="clip0_1396_16657">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="matrix(-1 0 0 1 18 0)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const LocationDot = ({ color = "#FF6B38" }) => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.59554 5.12424C7.59554 6.30266 6.6528 7.2192 5.50057 7.2192C4.32215 7.2192 3.40561 6.30266 3.40561 5.12424C3.40561 3.97201 4.32215 3.02927 5.50057 3.02927C6.6528 3.02927 7.59554 3.97201 7.59554 5.12424ZM5.50057 4.28625C5.0292 4.28625 4.66259 4.67906 4.66259 5.12424C4.66259 5.59561 5.0292 5.96222 5.50057 5.96222C5.94575 5.96222 6.33856 5.59561 6.33856 5.12424C6.33856 4.67906 5.94575 4.28625 5.50057 4.28625ZM10.5285 5.12424C10.5285 7.4287 7.4646 11.4877 6.10287 13.1899C5.78863 13.5827 5.18633 13.5827 4.87208 13.1899C3.51036 11.4877 0.472656 7.4287 0.472656 5.12424C0.472656 2.34841 2.69856 0.0963228 5.50057 0.0963228C8.2764 0.0963228 10.5285 2.34841 10.5285 5.12424ZM5.50057 1.3533C3.40561 1.3533 1.72964 3.05546 1.72964 5.12424C1.72964 5.46467 1.83438 5.96222 2.12244 6.64309C2.38431 7.27158 2.77712 8.00481 3.2223 8.73805C3.98172 9.94266 4.8459 11.0949 5.50057 11.9329C6.12906 11.0949 6.99323 9.94266 7.75266 8.73805C8.19784 8.00481 8.59064 7.27158 8.85251 6.64309C9.14057 5.96222 9.27151 5.46467 9.27151 5.12424C9.27151 3.05546 7.56935 1.3533 5.50057 1.3533Z"
      fill="#8F8F8F"
    />
  </svg>
);
export const ThingsToDo = ({ color = "#FF6B38" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1396_16665)">
      <rect
        x="5"
        y="1"
        width="13.0021"
        height="2.14318"
        rx="1.07159"
        fill="#FF6B38"
      />
      <rect
        x="5"
        y="9.57812"
        width="13.0021"
        height="2.14318"
        rx="1.07159"
        fill="#FF6B38"
      />
      <rect
        x="5"
        y="5.28125"
        width="9.00147"
        height="2.14318"
        rx="1.07159"
        fill="#FF6B38"
      />
      <rect
        x="5"
        y="13.8594"
        width="9.00147"
        height="2.14318"
        rx="1.07159"
        fill="#FF6B38"
      />
      <rect y="1" width="3.00049" height="3" rx="1.5" fill="#FF6B38" />
      <rect y="9.57812" width="3.00049" height="3" rx="1.5" fill="#FF6B38" />
    </g>
    <defs>
      <clipPath id="clip0_1396_16665">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="matrix(-1 0 0 1 18 0)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const People_svg = ({ color = "#FF6B38" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1396_16679)">
      <path
        d="M12.2622 16.0013C10.6777 16.0013 9.09362 16.0013 7.50907 16.0013C6.8548 16.0013 6.53789 15.6521 6.55118 14.9481C6.59719 12.4723 8.41175 10.2551 10.7119 9.95064C11.8835 9.79542 13.0739 9.75389 14.2398 10.0288C16.2906 10.5125 17.8368 12.4691 17.9824 14.7104C17.9881 14.7989 17.9962 14.8875 17.9998 14.976C18.0254 15.6149 17.6865 15.9997 17.0915 16.0008C16.1014 16.0029 15.1113 16.0013 14.1207 16.0013C13.5012 16.0013 12.8812 16.0013 12.2617 16.0013H12.2622Z"
        fill="#FF6B38"
      />
      <path
        d="M4.48935 8.99791C2.54902 8.99463 0.991834 7.4157 1.00003 5.45965C1.00768 3.55334 2.60586 1.98589 4.52925 2.0001C6.43132 2.01376 7.99452 3.58067 7.99999 5.47878C8.00545 7.42335 6.43132 9.00173 4.48935 8.99791Z"
        fill="#FF6B38"
      />
      <path
        d="M12.4907 8.99789C10.55 8.99461 8.99292 7.41677 9.00002 5.46127C9.00713 3.55387 10.6041 1.9875 12.5278 2.00008C14.4369 2.01265 16.0136 3.60087 15.9999 5.49789C15.9857 7.44409 14.4248 9.00117 12.4907 8.99789Z"
        fill="#FF6B38"
      />
      <path
        d="M6.81475 10.1724C5.39223 11.8333 4.69656 13.721 4.99712 15.9946C4.96645 15.9946 4.89898 15.9946 4.83151 15.9946C3.57869 15.9946 2.32638 15.9946 1.07356 15.9946C0.268506 15.9946 -0.00751237 15.7011 0.000154816 14.8337C0.0160003 13.0247 0.721893 11.6081 2.14083 10.6156C2.77772 10.1702 3.48668 9.92751 4.2488 9.88543C5.04772 9.84171 5.84613 9.82039 6.62052 10.0975C6.67981 10.1188 6.73859 10.1428 6.81475 10.1718V10.1724Z"
        fill="#FF6B38"
      />
    </g>
    <defs>
      <clipPath id="clip0_1396_16679">
        <rect width="18" height="14" fill="white" transform="translate(0 2)" />
      </clipPath>
    </defs>
  </svg>
);
export const CalendarSvg = ({ color = "#FF6B38" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4.4375C1 3.33293 1.89543 2.4375 3 2.4375H15C16.1046 2.4375 17 3.33293 17 4.4375V6.12961H1V4.4375Z"
      fill="#FF6B38"
    />
    <path
      d="M1 8.38281H17V15.4977C17 16.3262 16.3284 16.9977 15.5 16.9977H2.5C1.67157 16.9977 1 16.3262 1 15.4977V8.38281Z"
      fill="#FF6B38"
    />
    <rect
      x="11.2852"
      y="1"
      width="2.28571"
      height="3.69211"
      rx="1.14286"
      fill="#FF6B38"
    />
    <rect
      x="4.42578"
      y="1"
      width="2.28571"
      height="3.69211"
      rx="1.14286"
      fill="#FF6B38"
    />
  </svg>
);
export const ChartIcon = ({ color = "#FF6B38" }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1396_16704)">
      <path
        d="M3.65625 17.4375H2.53125C2.30747 17.4375 2.09286 17.3486 1.93463 17.1904C1.77639 17.0321 1.6875 16.8175 1.6875 16.5937V11.5312C1.6875 11.3075 1.77639 11.0929 1.93463 10.9346C2.09286 10.7764 2.30747 10.6875 2.53125 10.6875H3.65625C3.88003 10.6875 4.09464 10.7764 4.25287 10.9346C4.4111 11.0929 4.5 11.3075 4.5 11.5312V16.5937C4.5 16.8175 4.4111 17.0321 4.25287 17.1904C4.09464 17.3486 3.88003 17.4375 3.65625 17.4375Z"
        fill="#FF6B38"
      />
      <path
        d="M11.5312 17.4375H10.4062C10.1825 17.4375 9.96786 17.3486 9.80963 17.1904C9.6514 17.0321 9.5625 16.8175 9.5625 16.5937V8.15625C9.5625 7.93247 9.6514 7.71786 9.80963 7.55963C9.96786 7.40139 10.1825 7.3125 10.4062 7.3125H11.5312C11.755 7.3125 11.9696 7.40139 12.1279 7.55963C12.2861 7.71786 12.375 7.93247 12.375 8.15625V16.5937C12.375 16.8175 12.2861 17.0321 12.1279 17.1904C11.9696 17.3486 11.755 17.4375 11.5312 17.4375Z"
        fill="#FF6B38"
      />
      <path
        d="M15.4687 17.4375H14.3437C14.12 17.4375 13.9054 17.3486 13.7471 17.1904C13.5889 17.0321 13.5 16.8175 13.5 16.5937V4.21875C13.5 3.99497 13.5889 3.78036 13.7471 3.62213C13.9054 3.46389 14.12 3.375 14.3437 3.375H15.4687C15.6925 3.375 15.9071 3.46389 16.0654 3.62213C16.2236 3.78036 16.3125 3.99497 16.3125 4.21875V16.5937C16.3125 16.8175 16.2236 17.0321 16.0654 17.1904C15.9071 17.3486 15.6925 17.4375 15.4687 17.4375Z"
        fill="#FF6B38"
      />
      <path
        d="M7.59375 17.4375H6.46875C6.24497 17.4375 6.03036 17.3486 5.87213 17.1904C5.71389 17.0321 5.625 16.8175 5.625 16.5937V1.40625C5.625 1.18247 5.71389 0.967862 5.87213 0.809629C6.03036 0.651395 6.24497 0.5625 6.46875 0.5625H7.59375C7.81753 0.5625 8.03214 0.651395 8.19037 0.809629C8.3486 0.967862 8.4375 1.18247 8.4375 1.40625V16.5937C8.4375 16.8175 8.3486 17.0321 8.19037 17.1904C8.03214 17.3486 7.81753 17.4375 7.59375 17.4375Z"
        fill="#FF6B38"
      />
    </g>
    <defs>
      <clipPath id="clip0_1396_16704">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="matrix(-1 0 0 1 18 0)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const printIconWhite = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1667 14.1667H15.8333C16.7538 14.1667 17.5 13.4205 17.5 12.5V9.16667C17.5 8.24619 16.7538 7.5 15.8333 7.5H4.16667C3.24619 7.5 2.5 8.24619 2.5 9.16667V12.5C2.5 13.4205 3.24619 14.1667 4.16667 14.1667H5.83333"
      stroke="#F1F3F4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1693 7.5V4.16667C14.1693 3.24619 13.4231 2.5 12.5026 2.5H7.5026C6.58213 2.5 5.83594 3.24619 5.83594 4.16667V7.5"
      stroke="#F8F8F8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="5.83594"
      y="10.8359"
      width="8.33333"
      height="6.66667"
      rx="2"
      stroke="#F8F8F8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BottomLeftShadow = ({ color = "#FFE39C" }) => {
  return (
    <svg
      width="175"
      height="176"
      viewBox="0 0 175 176"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7" filter="url(#filter0_f_1244_28586)">
        <ellipse cy="275.5" rx="62" ry="162.5" fill={color} />
      </g>
      <defs>
        <filter
          id="filter0_f_1244_28586"
          x="-174.1"
          y="0.900002"
          width="348.2"
          height="549.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="56.05"
            result="effect1_foregroundBlur_1244_28586"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const Linkedin_original = ({ color = "#FFE39C" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5244 0.750076H1.4754C1.08857 0.746139 0.715973 0.89582 0.439372 1.16627C0.162771 1.43673 0.00475591 1.80587 0 2.19269V19.3106C0.005616 19.6968 0.164009 20.0651 0.440516 20.3349C0.717024 20.6046 1.08913 20.7539 1.4754 20.7499H18.5244C18.9113 20.753 19.2836 20.6028 19.5601 20.3322C19.8366 20.0616 19.9947 19.6925 19.9998 19.3057V2.18777C19.9929 1.80208 19.8341 1.4347 19.5578 1.16549C19.2816 0.896279 18.9102 0.74699 18.5244 0.750076Z"
        fill="#0076B2"
      />
      <path
        d="M2.96067 8.24625H5.9295V17.7986H2.96067V8.24625ZM4.44591 3.49219C4.78642 3.49219 5.11928 3.59318 5.40238 3.78239C5.68548 3.9716 5.9061 4.24053 6.03634 4.55515C6.16657 4.86977 6.20056 5.21595 6.13401 5.5499C6.06746 5.88384 5.90336 6.19055 5.66247 6.43121C5.42158 6.67187 5.11472 6.83568 4.78071 6.90191C4.4467 6.96814 4.10056 6.93382 3.78606 6.80329C3.47156 6.67275 3.20285 6.45188 3.0139 6.1686C2.82496 5.88531 2.72429 5.55236 2.72461 5.21185C2.72504 4.75561 2.90659 4.31822 3.22935 3.99576C3.5521 3.67331 3.98968 3.49219 4.44591 3.49219Z"
        fill="white"
      />
      <path
        d="M7.79102 8.24679H10.6369V9.55825H10.6762C11.073 8.80744 12.0402 8.01564 13.4844 8.01564C16.491 8.00908 17.0483 9.98776 17.0483 12.5533V17.7992H14.0795V13.1517C14.0795 12.0451 14.0598 10.6205 12.5369 10.6205C11.0139 10.6205 10.7549 11.8271 10.7549 13.0795V17.7992H7.79102V8.24679Z"
        fill="white"
      />
    </svg>
  );
};
export const Google_original = ({ color = "#FFE39C" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.575 10.7276C19.575 10.0693 19.5167 9.44427 19.4167 8.83594H10V12.5943H15.3917C15.15 13.8276 14.4417 14.8693 13.3917 15.5776V18.0776H16.6083C18.4917 16.3359 19.575 13.7693 19.575 10.7276Z"
        fill="#4285F4"
      />
      <path
        d="M9.99922 20.5018C12.6992 20.5018 14.9576 19.6018 16.6076 18.0768L13.3909 15.5768C12.4909 16.1768 11.3492 16.5435 9.99922 16.5435C7.39089 16.5435 5.18255 14.7852 4.39089 12.4102H1.07422V14.9852C2.71589 18.2518 6.09089 20.5018 9.99922 20.5018Z"
        fill="#34A853"
      />
      <path
        d="M4.39167 12.4073C4.18333 11.8073 4.075 11.1656 4.075 10.499C4.075 9.83229 4.19167 9.19062 4.39167 8.59062V6.01562H1.075C0.391666 7.36562 0 8.88229 0 10.499C0 12.1156 0.391666 13.6323 1.075 14.9823L4.39167 12.4073Z"
        fill="#FBBC05"
      />
      <path
        d="M9.99922 4.45833C11.4742 4.45833 12.7909 4.96667 13.8326 5.95834L16.6826 3.10833C14.9576 1.49167 12.6992 0.5 9.99922 0.5C6.09089 0.5 2.71589 2.75 1.07422 6.01667L4.39089 8.59167C5.18255 6.21667 7.39089 4.45833 9.99922 4.45833Z"
        fill="#EA4335"
      />
    </svg>
  );
};

// color - shadow color ("#FF8536"-yellow)
export const BottomRightShadow = ({
  color = "#FFE39C",
  height = "209",
  width = "101",
}) => {
  return (
    <svg
      style={{ borderBottomRightRadius: 10 }}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7" filter="url(#filter0_f_1331_62791)">
        <ellipse cx="177.5" cy="285.5" rx="54.5" ry="162.5" fill={color} />
      </g>
      <defs>
        <filter
          id="filter0_f_1331_62791"
          x="0.5"
          y="0.5"
          width="354"
          height="570"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="61.25"
            result="effect1_foregroundBlur_1331_62791"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const LeftSliderIcon = ({ onClick, color = "#262626" }) => (
  <div className="cursor-pointer" onClick={onClick}>
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="25" height="25" rx="11.5" stroke={color} />
      <path d="M17 21L9 12.9292L17 5" stroke="#212121" strokeMiterlimit="10" />
    </svg>
  </div>
);

export const RightSliderIcon = ({ onClick, color = "#262626" }) => (
  <div className="cursor-pointer" onClick={onClick}>
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="25.5"
        y="25.5"
        width="25"
        height="25"
        rx="11.5"
        transform="rotate(-180 25.5 25.5)"
        stroke={color}
      />
      <path d="M9 5L17 13.0708L9 21" stroke="#212121" strokeMiterlimit="10" />
    </svg>
  </div>
);

export const ClockIcon = ({ color }) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8.5"
      cy="8"
      r="6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="8.5"
      cy="8"
      r="6"
      stroke="black"
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 4.66406V7.9974L10.5 9.9974"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 4.66406V7.9974L10.5 9.9974"
      stroke="black"
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LocationIcon = ({ color = "#8F8F8F" }) => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.12288 5.29611C7.12288 6.47453 6.18015 7.39108 5.02792 7.39108C3.8495 7.39108 2.93295 6.47453 2.93295 5.29611C2.93295 4.14388 3.8495 3.20115 5.02792 3.20115C6.18015 3.20115 7.12288 4.14388 7.12288 5.29611ZM5.02792 4.45813C4.55655 4.45813 4.18993 4.85093 4.18993 5.29611C4.18993 5.76748 4.55655 6.1341 5.02792 6.1341C5.4731 6.1341 5.8659 5.76748 5.8659 5.29611C5.8659 4.85093 5.4731 4.45813 5.02792 4.45813ZM10.0558 5.29611C10.0558 7.60057 6.99194 11.6596 5.63022 13.3617C5.31597 13.7545 4.71367 13.7545 4.39943 13.3617C3.0377 11.6596 0 7.60057 0 5.29611C0 2.52028 2.2259 0.268198 5.02792 0.268198C7.80374 0.268198 10.0558 2.52028 10.0558 5.29611ZM5.02792 1.52518C2.93295 1.52518 1.25698 3.22734 1.25698 5.29611C1.25698 5.63654 1.36173 6.1341 1.64978 6.81496C1.91166 7.44345 2.30446 8.17669 2.74964 8.90993C3.50907 10.1145 4.37324 11.2668 5.02792 12.1047C5.6564 11.2668 6.52058 10.1145 7.28 8.90993C7.72518 8.17669 8.11799 7.44345 8.37986 6.81496C8.66792 6.1341 8.79885 5.63654 8.79885 5.29611C8.79885 3.22734 7.09669 1.52518 5.02792 1.52518Z"
      fill={color}
    />
  </svg>
);
export const Progress_Circle = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="22.5"
        cy="22.5"
        r="22.5"
        fill="url(#paint0_linear_1318_117383)"
      />
      <path
        d="M22.1169 16.76H18.4689V14.648H24.3729V32H22.1169V16.76Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1318_117383"
          x1="45"
          y1="22.2936"
          x2="-1.09309e-08"
          y2="22.2936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3302E" />
          <stop offset="0.447917" stopColor="#FF6B38" />
          <stop offset="1" stopColor="#FFA380" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const IntroIcon = () => {
  return (
    <svg
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1318_117504)">
        <rect x="6" y="2" width="30" height="30" rx="12" fill="#FF6B38" />
      </g>
      <circle
        cx="16.625"
        cy="20.25"
        r="1.875"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="25.375"
        cy="20.25"
        r="1.875"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 20.875V18.375L19.125 16.5L22.25 14L23.5 15.875H25.375"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="24.125"
        cy="12.125"
        r="0.625"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_1318_117504"
          x="0.5"
          y="-2.38419e-07"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.5" />
          <feGaussianBlur stdDeviation="2.75" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1318_117504"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1318_117504"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const Tiers_Icon = () => {
  return (
    <svg
      width="37"
      height="34"
      viewBox="0 0 37 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_1318_117436)">
        <rect
          x="4.49023"
          y="4"
          width="28.4539"
          height="26"
          rx="11"
          stroke="url(#paint0_linear_1318_117436)"
          strokeWidth="2"
        />
      </g>
      <circle
        cx="13.625"
        cy="20.25"
        r="1.875"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="22.375"
        cy="20.25"
        r="1.875"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 20.875V18.375L16.125 16.5L19.25 14L20.5 15.875H22.375"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="21.125"
        cy="12.125"
        r="0.625"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_f_1318_117436"
          x="0.890234"
          y="0.4"
          width="35.6531"
          height="33.2"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.3"
            result="effect1_foregroundBlur_1318_117436"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1318_117436"
          x1="7.93143"
          y1="4.75"
          x2="31.0428"
          y2="31.7721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F97533" />
          <stop offset="1" stopColor="#FFD4B8" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const Couse_profile_Icon = () => {
  return (
    <svg
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1318_117441)">
        <rect x="6" y="2" width="30" height="30" rx="12" fill="#FF6B38" />
      </g>
      <path
        d="M18.5 12.625H17.25C16.5596 12.625 16 13.1846 16 13.875V21.375C16 22.0654 16.5596 22.625 17.25 22.625H20.8106"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.75 17V13.875C24.75 13.1846 24.1904 12.625 23.5 12.625H22.25"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="18.5"
        y="11.375"
        width="3.75"
        height="2.5"
        rx="1.25"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 16.375H21"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 18.875H20.375"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="23.8125"
        cy="20.4375"
        r="1.5625"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0625 21.6875L26.625 23.25"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_1318_117441"
          x="0.5"
          y="-2.38419e-07"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.5" />
          <feGaussianBlur stdDeviation="2.75" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1318_117441"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1318_117441"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const Bag_icon = () => {
  return (
    <svg
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1318_117447)">
        <rect x="6" y="2" width="30" height="30" rx="12" fill="#FF6B38" />
      </g>
      <rect
        x="15.375"
        y="13.875"
        width="11.25"
        height="8.125"
        rx="2"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 13.875V12.625C18.5 11.9346 19.0596 11.375 19.75 11.375H22.25C22.9404 11.375 23.5 11.9346 23.5 12.625V13.875"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 17.0008V17.007"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.375 17.625C18.9131 19.4079 23.0869 19.4079 26.625 17.625"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_1318_117447"
          x="0.5"
          y="-2.38419e-07"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.5" />
          <feGaussianBlur stdDeviation="2.75" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1318_117447"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1318_117447"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const StatsIcon = () => {
  return (
    <svg
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1602_123636)">
        <rect x="6" y="2" width="30" height="30" rx="12" fill="#FF6B38" />
      </g>
      <g clip-path="url(#clip0_1602_123636)">
        <path
          d="M16.5469 24.0312H15.6094C15.4229 24.0312 15.2441 23.9572 15.1122 23.8253C14.9803 23.6934 14.9062 23.5146 14.9062 23.3281V19.1094C14.9062 18.9229 14.9803 18.7441 15.1122 18.6122C15.2441 18.4803 15.4229 18.4062 15.6094 18.4062H16.5469C16.7334 18.4062 16.9122 18.4803 17.0441 18.6122C17.1759 18.7441 17.25 18.9229 17.25 19.1094V23.3281C17.25 23.5146 17.1759 23.6934 17.0441 23.8253C16.9122 23.9572 16.7334 24.0312 16.5469 24.0312Z"
          fill="#F1F3F4"
        />
        <path
          d="M23.1094 24.0312H22.1719C21.9854 24.0312 21.8066 23.9572 21.6747 23.8253C21.5428 23.6934 21.4688 23.5146 21.4688 23.3281V16.2969C21.4688 16.1104 21.5428 15.9316 21.6747 15.7997C21.8066 15.6678 21.9854 15.5938 22.1719 15.5938H23.1094C23.2959 15.5938 23.4747 15.6678 23.6066 15.7997C23.7384 15.9316 23.8125 16.1104 23.8125 16.2969V23.3281C23.8125 23.5146 23.7384 23.6934 23.6066 23.8253C23.4747 23.9572 23.2959 24.0312 23.1094 24.0312Z"
          fill="#F1F3F4"
        />
        <path
          d="M26.3906 24.0312H25.4531C25.2666 24.0312 25.0878 23.9572 24.9559 23.8253C24.8241 23.6934 24.75 23.5146 24.75 23.3281V13.0156C24.75 12.8291 24.8241 12.6503 24.9559 12.5184C25.0878 12.3866 25.2666 12.3125 25.4531 12.3125H26.3906C26.5771 12.3125 26.7559 12.3866 26.8878 12.5184C27.0197 12.6503 27.0937 12.8291 27.0937 13.0156V23.3281C27.0937 23.5146 27.0197 23.6934 26.8878 23.8253C26.7559 23.9572 26.5771 24.0312 26.3906 24.0312Z"
          fill="#F1F3F4"
        />
        <path
          d="M19.8281 24.0312H18.8906C18.7041 24.0312 18.5253 23.9572 18.3934 23.8253C18.2616 23.6934 18.1875 23.5146 18.1875 23.3281V10.6719C18.1875 10.4854 18.2616 10.3066 18.3934 10.1747C18.5253 10.0428 18.7041 9.96875 18.8906 9.96875H19.8281C20.0146 9.96875 20.1934 10.0428 20.3253 10.1747C20.4572 10.3066 20.5312 10.4854 20.5312 10.6719V23.3281C20.5312 23.5146 20.4572 23.6934 20.3253 23.8253C20.1934 23.9572 20.0146 24.0312 19.8281 24.0312Z"
          fill="#F1F3F4"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1602_123636"
          x="0.5"
          y="-2.38419e-07"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.5" />
          <feGaussianBlur stdDeviation="2.75" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1602_123636"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1602_123636"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1602_123636">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(13.5 9.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Check = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.91406 7.0026L5.83073 9.91927L11.6641 4.08594"
        stroke="#8F8F8F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Checks = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.08594 7.0026L7.0026 9.91927L12.8359 4.08594"
        stroke="#8F8F8F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.51762 6.64905C1.32235 6.45379 1.00577 6.45379 0.810509 6.64905C0.615247 6.84431 0.615247 7.1609 0.810509 7.35616L1.51762 6.64905ZM3.72718 10.2728C3.92244 10.4681 4.23902 10.4681 4.43428 10.2728C4.62954 10.0776 4.62954 9.76098 4.43428 9.56572L3.72718 10.2728ZM6.64384 6.64905C6.44858 6.84431 6.44858 7.1609 6.64384 7.35616C6.8391 7.55142 7.15569 7.55142 7.35095 7.35616L6.64384 6.64905ZM10.2676 4.43949C10.4629 4.24423 10.4629 3.92765 10.2676 3.73238C10.0724 3.53712 9.75577 3.53712 9.56051 3.73238L10.2676 4.43949ZM0.810509 7.35616L3.72718 10.2728L4.43428 9.56572L1.51762 6.64905L0.810509 7.35616ZM7.35095 7.35616L10.2676 4.43949L9.56051 3.73238L6.64384 6.64905L7.35095 7.35616Z"
        fill="#8F8F8F"
      />
    </svg>
  );
};
export const PlusIcon = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#F8F8F8" />
      <path
        d="M7 12H17"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 7L12 17"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const PinIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4V10L7 14V16H17V14L15 10V4"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V21"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4H16"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const StarIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0056 16.7664L7.06109 19.5L8.00561 13.7101L4 9.61004L9.52774 8.76763L12 3.5L14.4723 8.76763L20 9.61004L15.9944 13.7101L16.9389 19.5L12.0056 16.7664Z"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SendBtn = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="22" fill="url(#paint0_linear_1671_53424)" />
      <path
        d="M15.1975 12.5454C14.9328 12.4685 14.6472 12.543 14.4538 12.7395C14.2604 12.936 14.1904 13.2227 14.2715 13.4862L16.7037 21.3911H25.2195C25.6337 21.3911 25.9695 21.7269 25.9695 22.1411C25.9695 22.5553 25.6337 22.8911 25.2195 22.8911H16.7038L14.2716 30.7958C14.1905 31.0592 14.2605 31.346 14.4539 31.5424C14.6473 31.7389 14.9329 31.8134 15.1976 31.7365C21.8962 29.7906 28.1169 26.7225 33.6428 22.7498C33.8388 22.6089 33.955 22.3823 33.955 22.1409C33.9549 21.8995 33.8388 21.6728 33.6427 21.5319C28.1169 17.5593 21.8961 14.4913 15.1975 12.5454Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1671_53424"
          x1="44"
          y1="21.7982"
          x2="-1.0688e-08"
          y2="21.7982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3302E" />
          <stop offset="0.447917" stopColor="#FF6B38" />
          <stop offset="1" stopColor="#FFA380" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const AlertCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="#4B465C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="white"
        stroke-opacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V12"
        stroke="#4B465C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V12"
        stroke="white"
        stroke-opacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0028 16H12.0128"
        stroke="#4B465C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0028 16H12.0128"
        stroke="white"
        stroke-opacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NotesIcon = () => {
  return (
    <svg
      width="163"
      height="150"
      viewBox="0 0 163 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1673_137832)">
        <rect x="18.5" y="14" width="126" height="114" rx="13" fill="white" />
      </g>
      <rect
        width="75.6"
        height="68.4"
        transform="translate(43.6953 36.7969)"
        fill="white"
      />
      <path
        d="M72.0453 70.9984H83.8578M72.0453 79.5484H83.8578M72.0453 88.0984H83.8578M93.3078 90.2359H100.395C104.31 90.2359 107.483 87.365 107.483 83.8234V54.2069C107.483 50.9722 104.821 48.2274 101.258 47.9598C100.082 47.8715 98.9026 47.7954 97.7193 47.7316M79.4463 47.7316C79.2425 48.3296 79.1328 48.9649 79.1328 49.6234C79.1328 50.8039 80.1905 51.7609 81.4953 51.7609H95.6703C96.9751 51.7609 98.0328 50.8039 98.0328 49.6234C98.0328 48.9649 97.9231 48.3296 97.7193 47.7316M79.4463 47.7316C80.3385 45.1135 83.0338 43.2109 86.2203 43.2109H90.9453C94.1318 43.2109 96.8271 45.1135 97.7193 47.7316M79.4463 47.7316C78.263 47.7954 77.0833 47.8715 75.9075 47.9598C72.3445 48.2274 69.6828 50.9722 69.6828 54.2069V60.3109M69.6828 60.3109H59.0516C57.0944 60.3109 55.5078 61.7464 55.5078 63.5172V95.5797C55.5078 97.3505 57.0944 98.7859 59.0516 98.7859H89.7641C91.7212 98.7859 93.3078 97.3505 93.3078 95.5797V63.5172C93.3078 61.7464 91.7212 60.3109 89.7641 60.3109H69.6828ZM64.9578 70.9984H64.9814V71.0198H64.9578V70.9984ZM64.9578 79.5484H64.9814V79.5698H64.9578V79.5484ZM64.9578 88.0984H64.9814V88.1198H64.9578V88.0984Z"
        stroke="#FF8536"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_1673_137832"
          x="0.5"
          y="0"
          width="162"
          height="150"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="9" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.391667 0 0 0 0 0.391667 0 0 0 0 0.391667 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1673_137832"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1673_137832"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const BottomArroe = () => {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.00246 1.5L5.41529 5.5L9.82812 1.5"
        stroke="#FF8536"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DownIcon = () => {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.17433 1.5L5.58717 5.5L10 1.5"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Report = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 8C12.5523 8 13 8.44772 13 9V12.75C13 13.3023 12.5523 13.75 12 13.75C11.4477 13.75 11 13.3023 11 12.75V9C11 8.44772 11.4477 8 12 8ZM11 15.75C11 15.1977 11.4477 14.75 12 14.75H12.0075C12.5598 14.75 13.0075 15.1977 13.0075 15.75V15.7575C13.0075 16.3098 12.5598 16.7575 12.0075 16.7575H12C11.4477 16.7575 11 16.3098 11 15.7575V15.75Z"
        fill="#FF8536"
      />
    </svg>
  );
};
export const Chat = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 12.7593C2.25 14.3604 3.37341 15.754 4.95746 15.987C6.04357 16.1467 7.14151 16.27 8.25 16.3556V21L12.326 16.924C12.6017 16.6483 12.9738 16.4919 13.3635 16.481C15.2869 16.4274 17.1821 16.2606 19.0425 15.9871C20.6266 15.7542 21.75 14.3606 21.75 12.7595V6.74056C21.75 5.13946 20.6266 3.74583 19.0425 3.51293C16.744 3.17501 14.3926 3 12.0003 3C9.60776 3 7.25612 3.17504 4.95747 3.51302C3.37342 3.74593 2.25 5.13956 2.25 6.74064V12.7593Z"
        stroke="#FF8536"
        strokeWidth="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Like = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.63257 10.25C7.43892 10.25 8.16648 9.80416 8.6641 9.16967C9.43726 8.18384 10.4117 7.3634 11.5255 6.77021C12.2477 6.38563 12.8743 5.81428 13.1781 5.05464C13.3908 4.5231 13.5 3.95587 13.5 3.38338V2.75C13.5 2.33579 13.8358 2 14.25 2C15.4926 2 16.5 3.00736 16.5 4.25C16.5 5.40163 16.2404 6.49263 15.7766 7.46771C15.511 8.02604 15.8836 8.75 16.5019 8.75M16.5019 8.75H19.6277C20.6544 8.75 21.5733 9.44399 21.682 10.4649C21.7269 10.8871 21.75 11.3158 21.75 11.75C21.75 14.5976 20.7581 17.2136 19.101 19.2712C18.7134 19.7525 18.1142 20 17.4962 20H13.4802C12.9966 20 12.5161 19.922 12.0572 19.7691L8.94278 18.7309C8.48393 18.578 8.00342 18.5 7.51975 18.5H5.90421M16.5019 8.75H14.25M5.90421 18.5C5.98702 18.7046 6.07713 18.9054 6.17423 19.1022C6.37137 19.5017 6.0962 20 5.65067 20H4.74289C3.85418 20 3.02991 19.482 2.77056 18.632C2.43208 17.5226 2.25 16.3451 2.25 15.125C2.25 13.5725 2.54481 12.0889 3.08149 10.7271C3.38655 9.95303 4.16733 9.5 4.99936 9.5H6.05212C6.52404 9.5 6.7973 10.0559 6.5523 10.4593C5.72588 11.8198 5.25 13.4168 5.25 15.125C5.25 16.3185 5.48232 17.4578 5.90421 18.5Z"
        stroke="#FF8536"
        strokeWidth="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Divider = () => {
  return (
    <svg
      width="174"
      height="2"
      viewBox="0 0 174 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1H174" stroke="url(#paint0_linear_1673_137775)" />
      <defs>
        <linearGradient
          id="paint0_linear_1673_137775"
          x1="0"
          y1="1"
          x2="172.322"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E0E1E2" stop-opacity="0" />
          <stop offset="0.5" stop-color="#E0E1E2" />
          <stop offset="1" stop-color="#E0E1E2" stop-opacity="0.15625" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const BasicInformation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <ellipse
        cx="9"
        cy="9.5"
        rx="9"
        ry="9.5"
        fill="url(#paint0_linear_1671_26659)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1671_26659"
          x1="18"
          y1="9.41285"
          x2="-4.37238e-09"
          y2="9.41285"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFA458" />
          <stop offset="1" stop-color="#FFE39C" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const EducationalInformation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <ellipse
        cx="9"
        cy="9.5"
        rx="9"
        ry="9.5"
        fill="url(#paint0_linear_1671_26666)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1671_26666"
          x1="18"
          y1="9.41285"
          x2="-4.37238e-09"
          y2="9.41285"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF6B38" />
          <stop offset="1" stop-color="#FFE39C" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const ProfessionalInformation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <ellipse
        cx="9"
        cy="9.5"
        rx="9"
        ry="9.5"
        fill="url(#paint0_linear_1671_26673)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1671_26673"
          x1="18"
          y1="9.41285"
          x2="-4.37238e-09"
          y2="9.41285"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E3302E" />
          <stop offset="0.447917" stop-color="#FF6B38" />
          <stop offset="1" stop-color="#FFA380" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const RightArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
    >
      <path d="M2 1L6 5.0354L2 9" stroke="#8F8F8F" stroke-miterlimit="10" />
    </svg>
  );
};
export const DotBall = ({ color = "#52B070" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <ellipse cx="9.5" cy="9.5" rx="9" ry="9.5" fill={color} />
    </svg>
  );
};
export const PeopleIcom = ({ color = "#52B070" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9.98438"
        cy="7"
        r="4"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.98438 21V19C3.98437 16.7909 5.77524 15 7.98438 15H11.9844C14.1935 15 15.9844 16.7909 15.9844 19V21"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.9844 3.13281C18.7543 3.58598 19.9922 5.1808 19.9922 7.00781C19.9922 8.83482 18.7543 10.4296 16.9844 10.8828"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.9844 20.9984V18.9984C21.9739 17.183 20.7422 15.6023 18.9844 15.1484"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const PencilIcon = ({ color = "#52B070" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 20.0003H8L18.5 9.5003C19.6046 8.39573 19.6046 6.60487 18.5 5.5003C17.3954 4.39573 15.6046 4.39573 14.5 5.5003L4 16.0003V20.0003"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 6.5L17.5 10.5"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TrashIcon = ({
  color = "#8F8F8F",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7H20"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 11V17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 11V17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 7L6 19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19L19 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 7V4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
// export const More_horiz = ({ color = "#52B070" }) => {
//   return (
//     <svg
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g clip-path="url(#clip0_1671_26589)">
//         <path
//           d="M10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16C10.9 16 10 16.9 10 18ZM10 6C10 7.1 10.9 8 12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6ZM10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12Z"
//           fill="#8F8F8F"
//         />
//       </g>
//       <defs>
//         <clipPath id="clip0_1671_26589">
//           <rect
//             width="24"
//             height="24"
//             fill="white"
//             transform="matrix(0 -1 1 0 0 24)"
//           />
//         </clipPath>
//       </defs>
//     </svg>
//   );
// };
export const XIcon = ({ color = "#52B070" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#4B465C"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="white"
        stroke-opacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const FormCheckboxButton = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1671_26585)">
        <rect x="4" y="2" width="18" height="18" rx="4" fill={color} />
      </g>
      <defs>
        <filter
          id="filter0_d_1671_26585"
          x="0"
          y="0"
          width="26"
          height="26"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.647059 0 0 0 0 0.639216 0 0 0 0 0.682353 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1671_26585"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1671_26585"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
export const CopyIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="8"
        y="8"
        width="12"
        height="12"
        rx="2"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 8V6C16 4.89543 15.1046 4 14 4H6C4.89543 4 4 4.89543 4 6V14C4 15.1046 4.89543 16 6 16H8"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const MessagesIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 14L18 11H11C10.4477 11 10 10.5523 10 10V4C10 3.44772 10.4477 3 11 3H20C20.5523 3 21 3.44772 21 4V14"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 15V17C14 17.5523 13.5523 18 13 18H6L3 21V11C3 10.4477 3.44772 10 4 10H6"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const MailIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="5"
        width="18"
        height="14"
        rx="2"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 7L12 13L21 7"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const BellRinging = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C16.3402 6.10655 17.8786 8.41425 18 11V14C18.1526 15.2608 18.8949 16.3742 20 17H4C5.10511 16.3742 5.84739 15.2608 6 14V11C6.12137 8.41425 7.65983 6.10655 10 5"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 17V18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18V17"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.001 6.727C20.3451 5.30025 19.3926 4.02969 18.207 3"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 6.727C3.65535 5.30044 4.60715 4.0299 5.792 3"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ScreenShare = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12V15C21 15.5523 20.5523 16 20 16H4C3.44772 16 3 15.5523 3 15V5C3 4.44772 3.44772 4 4 4H13"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 20H17"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 16V20"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 16V20"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 4H21V8"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 9L21 4"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const LinkIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13.9965C10.6583 14.6684 11.5594 15.047 12.5 15.047C13.4406 15.047 14.3417 14.6684 15 13.9965L19 9.99647C20.3807 8.61576 20.3807 6.37718 19 4.99647C17.6193 3.61576 15.3807 3.61576 14 4.99647L13.5 5.49647"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0004 10.0036C13.3421 9.33175 12.441 8.95312 11.5004 8.95312C10.5597 8.95312 9.65869 9.33175 9.00038 10.0036L5.00038 14.0036C3.61967 15.3843 3.61967 17.6229 5.00038 19.0036C6.38109 20.3843 8.61967 20.3843 10.0004 19.0036L10.5004 18.5036"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CloudIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83452 15.1251C3.66931 15.1251 1.91406 13.4461 1.91406 11.3751C1.91406 9.304 3.66931 7.62507 5.83452 7.62507C6.16532 6.15135 7.34457 4.94841 8.92806 4.46938C10.5115 3.99036 12.2587 4.30802 13.5114 5.30272C14.7641 6.29741 15.332 7.81802 15.0012 9.29174H15.8345C17.4453 9.29174 18.7512 10.5976 18.7512 12.2084C18.7512 13.8192 17.4453 15.1251 15.8345 15.1251H15.0012"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 12.625L10 10.125L12.5 12.625"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9987 10.125V17.625"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UploadFileIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.668 3V6.33333C11.668 6.79357 12.0411 7.16667 12.5013 7.16667H15.8346"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.168 18H5.83464C4.91416 18 4.16797 17.2538 4.16797 16.3333V4.66667C4.16797 3.74619 4.91416 3 5.83464 3H11.668L15.8346 7.16667V16.3333C15.8346 17.2538 15.0884 18 14.168 18Z"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9987 9.66797V14.668"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 12.168L10 9.66797L12.5 12.168"
        stroke="#8F8F8F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
// export const CloudIcon = ({ color = "#FF6B38" }) => {
//   return (
//     <svg
//       width="20"
//       height="21"
//       viewBox="0 0 20 21"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M5.83452 15.1251C3.66931 15.1251 1.91406 13.4461 1.91406 11.3751C1.91406 9.304 3.66931 7.62507 5.83452 7.62507C6.16532 6.15135 7.34457 4.94841 8.92806 4.46938C10.5115 3.99036 12.2587 4.30802 13.5114 5.30272C14.7641 6.29741 15.332 7.81802 15.0012 9.29174H15.8345C17.4453 9.29174 18.7512 10.5976 18.7512 12.2084C18.7512 13.8192 17.4453 15.1251 15.8345 15.1251H15.0012"
//         stroke="#F1F3F4"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M7.5 12.625L10 10.125L12.5 12.625"
//         stroke="#F1F3F4"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <path
//         d="M9.9987 10.125V17.625"
//         stroke="#F1F3F4"
//         strokeWidth="1.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// };
export const IconPlus = ({ color = "" }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4987 4.16797V15.8346"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66797 9.9987H16.3346"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PencilSquareSolid = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2312 2.26884C21.206 1.24372 19.544 1.24372 18.5188 2.26884L17.3617 3.42599L21.074 7.1383L22.2312 5.98116C23.2563 4.95603 23.2563 3.29397 22.2312 2.26884Z"
        fill="#8F8F8F"
      />
      <path
        d="M20.0133 8.19896L16.301 4.48665L7.90019 12.8875C7.28341 13.5043 6.83002 14.265 6.581 15.101L5.78122 17.7859C5.7026 18.0498 5.77494 18.3356 5.96967 18.5303C6.1644 18.725 6.45019 18.7974 6.71412 18.7188L9.39901 17.919C10.235 17.67 10.9957 17.2166 11.6125 16.5998L20.0133 8.19896Z"
        fill="#8F8F8F"
      />
      <path
        d="M5.75 5.24999C4.09315 5.24999 2.75 6.59314 2.75 8.24999V18.75C2.75 20.4068 4.09315 21.75 5.75 21.75H16.25C17.9069 21.75 19.25 20.4068 19.25 18.75V13.5C19.25 13.0858 18.9142 12.75 18.5 12.75C18.0858 12.75 17.75 13.0858 17.75 13.5V18.75C17.75 19.5784 17.0784 20.25 16.25 20.25H5.75C4.92157 20.25 4.25 19.5784 4.25 18.75V8.24999C4.25 7.42156 4.92157 6.74999 5.75 6.74999H11C11.4142 6.74999 11.75 6.41421 11.75 5.99999C11.75 5.58578 11.4142 5.24999 11 5.24999H5.75Z"
        fill="#8F8F8F"
      />
      <path
        d="M22.2312 2.26884C21.206 1.24372 19.544 1.24372 18.5188 2.26884L17.3617 3.42599L21.074 7.1383L22.2312 5.98116C23.2563 4.95603 23.2563 3.29397 22.2312 2.26884Z"
        stroke="#8F8F8F"
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0133 8.19896L16.301 4.48665L7.90019 12.8875C7.28341 13.5043 6.83002 14.265 6.581 15.101L5.78122 17.7859C5.7026 18.0498 5.77494 18.3356 5.96967 18.5303C6.1644 18.725 6.45019 18.7974 6.71412 18.7188L9.39901 17.919C10.235 17.67 10.9957 17.2166 11.6125 16.5998L20.0133 8.19896Z"
        stroke="#8F8F8F"
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.75 5.24999C4.09315 5.24999 2.75 6.59314 2.75 8.24999V18.75C2.75 20.4068 4.09315 21.75 5.75 21.75H16.25C17.9069 21.75 19.25 20.4068 19.25 18.75V13.5C19.25 13.0858 18.9142 12.75 18.5 12.75C18.0858 12.75 17.75 13.0858 17.75 13.5V18.75C17.75 19.5784 17.0784 20.25 16.25 20.25H5.75C4.92157 20.25 4.25 19.5784 4.25 18.75V8.24999C4.25 7.42156 4.92157 6.74999 5.75 6.74999H11C11.4142 6.74999 11.75 6.41421 11.75 5.99999C11.75 5.58578 11.4142 5.24999 11 5.24999H5.75Z"
        stroke="#8F8F8F"
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const AchievementDivider = () => {
  return (
    <svg
      width="100%"
      height="2"
      viewBox="0 0 916 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 1H916"
        stroke="url(#paint0_linear_3573_305513)"
        stroke-width="1.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3573_305513"
          x1="0"
          y1="1"
          x2="907.164"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E0E1E2" stop-opacity="0" />
          <stop offset="0.5" stop-color="#E0E1E2" />
          <stop offset="1" stop-color="#E0E1E2" stop-opacity="0.15625" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const BorderLine = () => {
  return (
    <svg
      width="742"
      height="2"
      viewBox="0 0 742 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1H742" stroke="url(#paint0_linear_1197_33276)" />
      <defs>
        <linearGradient
          id="paint0_linear_1197_33276"
          x1="0"
          y1="1"
          x2="734.842"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0E1E2" stopOpacity="0" />
          <stop offset="0.5" stopColor="#E0E1E2" />
          <stop offset="1" stopColor="#E0E1E2" stopOpacity="0.15625" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const LearnMore = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1.30078"
        width="25"
        height="25"
        rx="12.5"
        stroke="#262626"
      />
      <path
        d="M9 5.80078L17 13.8716L9 21.8008"
        stroke="#212121"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
export const DownloadIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.83203 14.168V15.8346C3.83203 16.7551 4.57822 17.5013 5.4987 17.5013H15.4987C16.4192 17.5013 17.1654 16.7551 17.1654 15.8346V14.168"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33203 9.16797L10.4987 13.3346L14.6654 9.16797"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4987 3.33203V13.332"
        stroke="#F1F3F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ShareIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="5"
        cy="10.5"
        r="2.5"
        stroke="url(#paint0_linear_1279_28564)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="15"
        cy="5.5"
        r="2.5"
        stroke="url(#paint1_linear_1279_28564)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="15"
        cy="15.5"
        r="2.5"
        stroke="url(#paint2_linear_1279_28564)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.25 9.41536L12.75 6.58203"
        stroke="url(#paint3_linear_1279_28564)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.25 11.582L12.75 14.4154"
        stroke="url(#paint4_linear_1279_28564)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1279_28564"
          x1="7.5"
          y1="10.4771"
          x2="2.5"
          y2="10.4771"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3302E" />
          <stop offset="0.447917" stopColor="#FF6B38" />
          <stop offset="1" stopColor="#FFA380" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1279_28564"
          x1="17.5"
          y1="5.47707"
          x2="12.5"
          y2="5.47707"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3302E" />
          <stop offset="0.447917" stopColor="#FF6B38" />
          <stop offset="1" stopColor="#FFA380" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1279_28564"
          x1="17.5"
          y1="15.4771"
          x2="12.5"
          y2="15.4771"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3302E" />
          <stop offset="0.447917" stopColor="#FF6B38" />
          <stop offset="1" stopColor="#FFA380" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1279_28564"
          x1="12.75"
          y1="7.9857"
          x2="7.25"
          y2="7.9857"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3302E" />
          <stop offset="0.447917" stopColor="#FF6B38" />
          <stop offset="1" stopColor="#FFA380" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1279_28564"
          x1="12.75"
          y1="12.9857"
          x2="7.25"
          y2="12.9857"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3302E" />
          <stop offset="0.447917" stopColor="#FF6B38" />
          <stop offset="1" stopColor="#FFA380" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const VerticalLine = () => {
  return (
    <svg
      width="2"
      height="61"
      viewBox="0 0 2 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 0V61" stroke="#A2A2A2" />
    </svg>
  );
};
export const ListIcon = ({ color = "#FF6B38" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.98438 6H20.9844"
        stroke="#8F8F8F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.98438 12H20.9844"
        stroke="#8F8F8F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.98438 18H20.9844"
        stroke="#8F8F8F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.98438 6.00281V6.01281"
        stroke="#8F8F8F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.98438 12.0028V12.0128"
        stroke="#8F8F8F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.98438 17.9989V18.0089"
        stroke="#8F8F8F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const SurveyMenu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M4 6.5H20"
        stroke="#F1F3F4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 12.5H20"
        stroke="#F1F3F4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 18.5H20"
        stroke="#F1F3F4"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
